import React, { memo, useState } from 'react';
import cx from 'classnames';
import filter from 'ramda/src/filter';
import Pagination from '@components/@core/Pagination';
import ScorecardItem from '@components/ScorecardItem';
import TaskEmptyList from '@components/TaskEmptyList';
import TaskHeader from '@components/@core/TaskHeader';
import { inPage } from '~/services/util';

const Scorecard = ({ className, userId, title, tasks, completed }) => {
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(5);
    const data = filter((task) => (completed ? !!task.completed_at : !task.completed_at), tasks);

    return (
        <div className={cx('card', className)}>
            <TaskHeader className="pb-2" title={title} />
            {data.length > 0 ? (
                data.map((task, index) => inPage(index, page, per) && <ScorecardItem key={task.id} userId={userId} task={task} />)
            ) : (
                <TaskEmptyList message={`You have no ${completed ? 'completed' : 'incomplete'} Scorecard tasks.`} />
            )}
            <Pagination className="pagination px-0" current={page} pers={[]} per={per} total={Math.ceil(data.length / per)} onChange={(e) => setPage(e)} />
        </div>
    );
};

export default memo(Scorecard);
